module.exports = __webpack_public_path__ + "media/PAG70-02.791a4a7f.mp3";